module.exports = __webpack_public_path__ + "assets/img/logo-white.2bf474de.png";